import React from "react";
import { Helmet } from "react-helmet";

import { moment } from "../../common/common";

import cookie from "react-cookies";
import queryString from "query-string";
import { connect } from "react-redux";


import { isIOS } from "react-device-detect";

import {
	setFilter,
	searchCarList,
	searchCarListMore,
	searchCarMapV2,
	searchCarMapMoreV2,
} from "../../../actions/carFindingAct";
import { getLoggedProfile } from "../../../actions/sessionAct";
import { init, getFilterConfig, getVehicleType, getVehicleMake } from "../../../model/car";
import { searchInHouse } from "../../../model/common";
import { mapSdk } from "../../../model/base";

import { commonErr } from "../../common/errors";
import { LoadingInlineTime } from "../../common/loading";
import { MessageBox, MessageLine, Empty } from "../../common/messagebox";
import WdTypeInfoBox from "../../common/wdtypeinfobox";
import { formatTitleInUrl, stypes, wdType, viewModes, formatTime } from "../../common/common";
import { initMap } from "../../common/wdfunction";

import Header from "../../components/header";
import ListView from "../listview";
import MapView from "../mapview";

import FilterPopup from "../filterpopup";
import FilterScreen from "../filterscreen";

import QuicklySearch from "../components/quicklysearch";

import QuicklyFilter from "../components/quicklyfilter";
import CarDetailPopup from "../cardetailpopup";
import SearchFilterBox from "../components/searchfilterbox";
import SearchBox from "../components/searchbox";
import Login from "../../login/login";
import SignUp from "../../login/signup";

import DateBox from "../../common/datebox";

import { IcListCarFinding, IcMapCarFinding, IcLocationSearch, IcCalendarSearch, IcNextCircle } from "../../common/svg";

import empty from "../../../static/images/empty/empty-mycar.svg";

const defPriceRange = {
	min: 500,
	max: 10000,
	step: 100,
};

const defLimitKMRange = {
	min: 0,
	max: 550,
	step: 50,
};

const defLimitKMPriceRange = {
	min: 0,
	max: 10,
	step: 5,
};

const defDPriceRange = {
	min: 0,
	max: 50,
	step: 5,
};

const defFuelCRange = {
	min: 0,
	max: 30,
	step: 5,
};

const defYearRange = {
	min: 2000,
	max: moment().year().valueOf(),
	step: 5,
};

const defSeatRange = {
	min: 2,
	max: 16,
	step: 2,
};

const defRadiusRange = {
	min: 5,
	max: 50,
	step: 3,
};

const calendarTemplate =
	'<div class="daterangepicker dropdown-menu home">' +
	'<p class="c-title">' +
	"Chọn ngày" +
	"</p>" +
	'<div class="calendar left">' +
	'<div class="calendar-table"></div>' +
	'<div class="daterangepicker_input">' +
	`<div class="line"></div>` +
	`<p class="c-title">Chọn giờ</p>` +
	'<div class="calendar-time">' +
	`<p class='pickup'>Nhận xe` +
	"<div></div>" +
	"</div>" +
	"</div>" +
	"</div>" +
	'<div class="calendar right">' +
	'<div class="calendar-table"></div>' +
	'<div class="daterangepicker_input">' +
	`<div class="line"></div>` +
	`<p class="c-title" style="height: 24px" ></p>` +
	'<div class="calendar-time">' +
	`<p class='pickup'>Trả xe` +
	"<div></div>" +
	'<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	"</div>" +
	"</div>" +
	"</div>" +
	'<div class="ranges">' +
	'<div class="range_inputs">' +
	'<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	"</div>" +
	"</div>" +
	"</div>" +
	"</div>";

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - (time % 60)) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

const preventDefault = (e) => e.preventDefault();

class CarFinding extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			errMsgBox: "",
			addressPlaceHolder:
				this.props.carFinding.filter.address !== "" ? this.props.carFinding.filter.address : "Vị trí trên bản đồ.",

			viewMode: viewModes.LIST,
			isOpenFilterBox: false,
			isOpenFilter: false,
			showAdvance: false,
			isShowPopup: false,
			popupCarId: "",
			isOpenSearching: false,
			showSearchTime: true,
			showLoginForm: false,
			showSignup: false,
			location: props.location,
			oriUrl: window.location.href,
			visible: true,
			visibleBottom: true,
			fixHeight: false,

			isCalendar: false,
			indexUrl: -1,
			prevUrl: ""
		};
		this.stype = stypes.SD;
		this.isSD = this.props.match.path === "/find/filter";
		this.prevScrollPos = window.scrollY;
		this.visible = true;
		this.visibleBottom = true;
		this.timeoutScroll = null;

		this.wrapperRef = React.createRef();
		this.map = React.createRef();
	}

	componentDidMount() {
		var startDate;
		var endDate;
		var startTime;
		var endTime;
		var lat = this.props.carFinding.filter.lat;
		var lng = this.props.carFinding.filter.lng;
		var address = this.props.carFinding.filter.address;
		var isAirDelivery = false;
		var deliveryId;
		var vehicleType;
		var vehicleMake;

		if (window.history.state?.prevUrl) {
			this.setState({
				prevUrl: window.history.state?.prevUrl
			})
		}
		// if (window.history && window.history.length < 3) {
		// 	this.setState({
		// 		indexUrl: 1
		// 	})
		// }

		if (this.props.appInit.err === commonErr.SUCCESS) { 
			this.setState({
				minDate: this.props.appInit.data.startDate,
				maxDate: this.props.appInit.data.endDate
			});
		}

		if (this.props.carFinding.filter.isOpenSearching) {
			this.setState({
				isOpenSearching: false,
			});
		}



		//overide filter by query params
		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);

			if (query.startDate) {
				startDate = moment(query.startDate * 1);
				startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}
			if (query.endDate) {
				endDate = moment(query.endDate * 1);
				endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}
			if (query.lat) {
				lat = query.lat * 1;
			}
			if (query.lng) {
				lng = query.lng * 1;
			}
			if (query.loc) {
				let buff = new Buffer(query.loc, "base64");
				const locStr = buff.toString("ascii");
				const locArray = locStr.split("-");
				lat = locArray[0] * 1;
				lng = locArray[1] * 1;
			}

			if (query.address) {
				address = query.address;
			}

			if (query.isAirDelivery) {
				isAirDelivery = query.isAirDelivery;
			}

			if (query.deliveryId) {
				deliveryId = query.deliveryId;
			}

			if (query.vtype) {
				vehicleType = query.vtype.includes(";") ? query.vtype.split(";") : [query.vtype];
			}

			if (query.vmake) {
				vehicleMake = query.vmake * 1;
			}

			//GA tracking
			// if (query.summer_game) {
			// 	cookie.save("_summer_game", query.summer_game, { path: "/" });
			// 	cookie.save("_summer_game", query.summer_game, { path: "/", domain: ".mioto.vn" });
			// } else {
			// 	cookie.remove("_summer_game", { path: "/" });
			// 	cookie.remove("_summer_game", { path: "/", domain: ".mioto.vn" });
			// }
			// if (query.wauth) {
			// 	cookie.save("_wauth_game", query.wauth, { path: "/" });
			// 	cookie.save("_wauth_game", query.wauth, { path: "/", domain: ".mioto.vn" });
			// }
			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_campaign) {
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/" });
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_medium) {
				cookie.save("_utm_medium", query.utm_medium, { path: "/" });
				cookie.save("_utm_medium", query.utm_medium, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_term) {
				cookie.save("_utm_term", query.utm_term, { path: "/" });
				cookie.save("_utm_term", query.utm_term, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		} else {
			//use cookies for missing params
			if (!address) {
				const cAddress = cookie.load("_maddr");
				if (cAddress) {
					address = cAddress;
				}
			}


			// check valid cookie before set
			if (
				cookie.load("_mstartts") < moment().add(1, "hours").valueOf() ||
				cookie.load("_mendts") < moment().add(1, "hours").valueOf()
			) {
				cookie.remove("_mstartts", { path: "/" });
				cookie.remove("_mendts", { path: "/" });
			}


			const cStartTs = cookie.load("_mstartts");

			if (cStartTs) {
				const cStartDate = moment(cStartTs * 1);
				startDate = cStartDate;
				startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}
	
			const cEndTs = cookie.load("_mendts");
			
			if (cEndTs) {
				endDate = moment(cEndTs * 1);
				endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}
		
		}

		

	

	
		this.setState({
			isAirDelivery: isAirDelivery,
		});

		if (address && address !== "") {
			if (lat && lng) {
				if (startDate && endDate) {
					const filter = {
						...this.props.carFinding.filter,
						address: address,
						lat: lat,
						lng: lng,
						startDate: startDate,
						endDate: endDate,
						startTime: startTime,
						endTime: endTime,
						deliveryId: deliveryId,
						directDelivery: isAirDelivery ? true : false,
						vehicleType: vehicleType ? vehicleType : undefined,
						vehicleMake: vehicleMake ? vehicleMake : 0,
					};

					this.setState({
						startDate: startDate,
						endDate: endDate,
						startTime: startTime,
						endTime: endTime,
						baseFilter: { ...filter },
					});

					this.setFilter(filter);
					this.searchCar(filter);
				} else {
					init().then((resp) => {
						const timeInit = resp.data.data;

						if (timeInit) {
							const filter = {
								...this.props.carFinding.filter,
								address: address,
								lat: lat,
								lng: lng,
								startDate: moment(timeInit.startTime),
								endDate: moment(timeInit.endTime),
								startTime: moment(timeInit.startTime).get("hour") * 60 + moment(timeInit.startTime).get("minute"),
								endTime: moment(timeInit.endTime).get("hour") * 60 + moment(timeInit.endTime).get("minute"),
								deliveryId: deliveryId,
								directDelivery: isAirDelivery ? true : false,
								vehicleType: vehicleType ? vehicleType : undefined,
								vehicleMake: vehicleMake ? vehicleMake : 0,
								stype: this.stype,
							};
							this.setState({
								baseFilter: { ...filter },
								addressBanner: address != "" && address,
								startDate: moment(timeInit.startTime),
								endDate: moment(timeInit.endTime),
								startTime: moment(timeInit.startTime).get("hour") * 60 + moment(timeInit.startTime).get("minute"),
								endTime: moment(timeInit.endTime).get("hour") * 60 + moment(timeInit.endTime).get("minute"),
							});
							this.setFilter(filter);
							this.searchCar(filter);
						} else {
							this.setState({
								err: commonErr.FAIL,
								errMsg: "Thời gian tìm kiếm không hợp lệ.",
							});
						}
					});
				}
			} else {
				if (mapSdk > 0) {
					searchInHouse(address)
						.then((response) => {
							if (response.data.data && response.data.data.locations.length > 0) {
								// const loc = response.data.items[0].position
								const loc = response.data.data.locations[0];
								location = { lat: loc.lat, lng: loc.lon };
							}

							let location;
							// For city featured, use lat, lng of dicstrict 1 of HCM
							if (address == "Hồ Chí Minh") {
								location = { lat: 10.771905, lng: 106.698264 };
							}

							if (startDate && endDate) {
								const filter = {
									...this.props.carFinding.filter,
									address: address,
									lat: location.lat,
									lng: location.lng,
									startDate: startDate,
									endDate: endDate,
									startTime: startTime,
									endTime: endTime,
									deliveryId: deliveryId,
									directDelivery: isAirDelivery ? true : false,
									vehicleType: vehicleType ? vehicleType : undefined,
									vehicleMake: vehicleMake ? vehicleMake : 0,
									stype: this.stype,
								};

								this.setState({
									baseFilter: { ...filter },
									addressBanner: address != "" && address,
									startDate: startDate,
									endDate: endDate,
									startTime: startTime,
									endTime: endTime,
								});
								this.setFilter(filter);
								this.searchCar(filter);
							} else {
								init().then((resp) => {
									const timeInit = resp.data.data;
									if (timeInit) {
										const filter = {
											...this.props.carFinding.filter,
											address: address,
											lat: location.lat,
											lng: location.lng,
											startDate: moment(timeInit.startTime),
											endDate: moment(timeInit.endTime),
											startTime: moment(timeInit.startTime).get("hour") * 60 + moment(timeInit.startTime).get("minute"),
											endTime: moment(timeInit.endTime).get("hour") * 60 + moment(timeInit.endTime).get("minute"),
											vehicleType: vehicleType ? vehicleType : undefined,
											vehicleMake: vehicleMake ? vehicleMake : 0,
											stype: this.stype,
										};
										this.setState({
											baseFilter: { ...filter },
											addressBanner: address != "" && address,
											startDate: moment(timeInit.startTime),
											endDate: moment(timeInit.endTime),
											startTime: moment(timeInit.startTime).get("hour") * 60 + moment(timeInit.startTime).get("minute"),
											endTime: moment(timeInit.endTime).get("hour") * 60 + moment(timeInit.endTime).get("minute"),
										});
										this.setFilter(filter);
										this.searchCar(filter);
									} else {
										this.setState({
											err: commonErr.FAIL,
											errMsg: "Thời gian tìm kiếm không hợp lệ.",
										});
									}
								});
							}
						})
						.catch((error) => {
							this.setState({
								err: commonErr.FAIL,
								errMsg: "Địa chỉ tìm kiếm không hợp lệ.",
								startDate: startDate,
								endDate: endDate,
								startTime: startTime,
								endTime: endTime,
							});
						});
				} else {
				}
			}
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Địa chỉ tìm kiếm không hợp lệ.",
			});
		}

		getFilterConfig().then((resp) => {
			if (resp.data.data) {
				this.setState({
					customFilterConfig: resp.data.data,
				});
			}
		});

		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});

		getVehicleMake().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleMakes: resp.data.data.vehicleMakes,
				});
			}
		});

		window.addEventListener("scroll", this.handleScroll);

		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga('send', 'event', utmSrc, "CAR_FINDING_BETA", utmExt);
		window.gtag("event", "CAR_FINDING", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		window.fbq("track", "CAR_FINDING");
	}

	UNSAFE_componentWillUnmount() {
		// important
		window.removeEventListener("scroll", this.handleScroll);
	}

	componentDidUpdate(props) {
		if (props.appInit.err !== this.props.appInit.err) {
			// Wait for redux init app fulfilled

			if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) { 
				this.setState({
					minDate: this.props.appInit.data.startDate,
					maxDate: this.props.appInit.data.endDate
				});
			}
		}
	}

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	onFixHeight = (fix) => {
		this.setState({
			fixHeight: fix,
		});
	};

	handleScroll = () => {
		const currentScrollPos = window.scrollY;
		this.visible = currentScrollPos < 89; //Height of Header
		this.visibleBottom = currentScrollPos < 89 || this.prevScrollPos > currentScrollPos;

		// clearTimeout(this.timeoutScroll);
		// if (currentScrollPos < this.prevScrollPos) {
		// 	this.timeoutScroll = setTimeout(() => {
		// 		this.visible = true;
		// 		this.setState({
		// 			visible: this.visible,
		// 		});
		// 		this.visibleBottom = true;
		// 		this.setState({
		// 			visibleBottom: this.visibleBottom,
		// 		});
		// 	}, 1000);
		// }

		// Header and filter
		if (this.visible !== this.state.visible && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visible: this.visible,
			});
		}

		//Show map button
		if (this.visibleBottom !== this.state.visibleBottom && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visibleBottom: this.visibleBottom,
			});
		}

		this.prevScrollPos = currentScrollPos;
	};

	//common
	setGMap = () => {
		this.setState({
			gmapLoaded: true,
		});
	};

	setListView = () => {
		this.setState({
			viewMode: viewModes.LIST,
		});
		this.searchCarList(this.props.carFinding.filter);
	};

	setMapView = () => {
		this.setState({
			viewMode: viewModes.MAP,
		});
	};

	toggleFilterBox = () => {
		this.setState({
			isOpenFilterBox: !this.state.isOpenFilterBox,
		});
	};

	hideFilterBox = () => {
		this.setState({
			isOpenFilterBox: false,
		});
	};

	toggleFilter = () => {
		this.setState({
			isOpenFilter: !this.state.isOpenFilter,
		});
	};

	hideFilter = () => {
		this.setState({
			isOpenFilter: false,
		});
	};

	setFilter = (filter) => {
		this.props.dispatch(setFilter(filter));
	};

	resetFilter = () => {
		let filter;

		const { startDate, endDate, address, lat, lng, minMiles, vehicleModel, ownerHostFiveStar } =
			this.props.carFinding.filter;
		filter = {
			...this.state.baseFilter,
			startDate: startDate,
			endDate: endDate,
			address: address,
			lat: lat,
			lng: lng,
			minMiles: minMiles,
			vehicleMake: 0,
			vehicleModel: [],
			ownerHostFiveStar: 0,
			directDelivery: false,
		};

		this.setFilter(filter);

		const { vehicleTypes } = this.state;

		for (let i = 0; i < vehicleTypes.length; ++i) {
			vehicleTypes[i].checked = false;
		}

		const allFeatures = this.state.customFilterConfig.allFeatures;
		for (var i = 0; i < allFeatures.length; ++i) {
			allFeatures[i].checked = false;
		}

		this.searchCar(filter);
	};

	searchCarList = (f) => {
		const filter = this.standarizeFilter(f, viewModes.LIST);
		this.props.dispatch(searchCarList(filter));
	};

	searchCarListMore = (f) => {
		const filter = this.standarizeFilter(f, viewModes.LIST);
		this.props.dispatch(searchCarListMore(filter));
	};

	searchCarMap = (f) => {
		const filter = this.standarizeFilter(f, viewModes.MAP);
		// this.props.dispatch(searchCarMap(filter));
		this.props.dispatch(searchCarMapV2(filter));
	};

	searchCarMapMore = (f) => {
		const filter = this.standarizeFilter(f, viewModes.MAP);
		// this.props.dispatch(searchCarMapMore(filter));
		this.props.dispatch(searchCarMapMoreV2(filter));
	};

	standarizeFilter = (filter, viewMode) => {
		const customFilterConfig = this.state.customFilterConfig;
		const maxPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxPrice
				? customFilterConfig.maxPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxPrice
			? customFilterConfig.wdMaxPrice / 1000
			: defPriceRange.max;
		const minPrice = this.isSD
			? customFilterConfig && customFilterConfig.minPrice
				? customFilterConfig.minPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMinPrice
			? customFilterConfig.wdMinPrice / 1000
			: defPriceRange.min;
		const maxDPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxDeliveryPrice
				? customFilterConfig.maxDeliveryPrice / 1000
				: defDPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxDeliveryPrice
			? customFilterConfig.wdMaxDeliveryPrice / 1000
			: defDPriceRange.max;
		//
		const minLimitKM =
			customFilterConfig && customFilterConfig.minLimitKM ? customFilterConfig.minLimitKM : defLimitKMRange.min;
		const maxLimitKM =
			customFilterConfig && customFilterConfig.maxLimitKM ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice =
			customFilterConfig && customFilterConfig.maxLimitKMPrice
				? customFilterConfig.maxLimitKMPrice / 1000 + 5
				: defLimitKMPriceRange.max;
		const minFuelC =
			customFilterConfig && customFilterConfig.minFuelC ? customFilterConfig.minFuelC : defFuelCRange.min;
		const maxFuelC =
			customFilterConfig && customFilterConfig.maxFuelC ? customFilterConfig.maxFuelC : defFuelCRange.max;
		const minSeat = customFilterConfig && customFilterConfig.seatMin ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = customFilterConfig && customFilterConfig.seatMax ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = customFilterConfig && customFilterConfig.yearMin ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = customFilterConfig && customFilterConfig.yearMax ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius =
			customFilterConfig && customFilterConfig.maxRadius ? customFilterConfig.maxRadius : defRadiusRange.max;

		return {
			...filter,
			minPrice: filter.minPrice > minPrice ? filter.minPrice : 0,
			maxPrice: filter.maxPrice < maxPrice ? filter.maxPrice : 0,
			dPrice: this.isSD
				? filter.directDelivery && filter.dPrice < maxDPrice
					? filter.dPrice
					: -1
				: /*WD*/ filter.dPrice < maxDPrice
				? filter.dPrice
				: -1,
			limitKM: filter.limitKM <= minLimitKM ? -1 : filter.limitKM >= maxLimitKM ? 0 : filter.limitKM,
			// limitKM: filter.limitKM < maxLimitKM ? filter.limitKM : -1,
			limitKMPrice: filter.limitKM > minLimitKM && filter.limitKMPrice < maxLimitKMPrice ? filter.limitKMPrice : -1,
			fuelC: filter.fuelC > minFuelC && filter.fuelC < maxFuelC ? filter.fuelC : 0,
			minSeat: filter.minSeat > minSeat && filter.minSeat < maxSeat ? filter.minSeat : 0,
			maxSeat: filter.maxSeat > minSeat && filter.maxSeat < maxSeat ? filter.maxSeat : 0,
			minYear: filter.minYear > minYear && filter.minYear < maxYear ? filter.minYear : 0,
			maxYear: filter.maxYear > minYear && filter.maxYear < maxYear ? filter.maxYear : 0,
			radius: viewMode === viewModes.LIST && filter.radius * 1.60934 >= maxRadius ? 0 : filter.radius,
		};
	};

	searchCar = (filter) => {
		// save search params cookies
	
		cookie.save("_maddr", filter.address, { path: "/" });
		cookie.save("_mlat", filter.lat, { path: "/" });
		cookie.save("_mlng", filter.lng, { path: "/" });
		cookie.save("_mstartts", filter.startDate.valueOf(), { path: "/" });
		cookie.save("_mendts", filter.endDate.valueOf(), { path: "/" });

		if (this.state.viewMode === viewModes.MAP) {
			this.searchCarMap(filter);
		} else {
			this.searchCarList(filter);
		}
	};

	setAddressPlaceHolder = (msg) => {
		this.setState({
			addressPlaceHolder: msg,
		});
	};

	onAddressChange = (address, i) => {
		const filter = {
			...this.props.carFinding.filter,
			address: address,
			isOpenSearching: true,
		};
		this.setFilter(filter);
	};

	onAddressFocus = (e, i) => {
		this.setState({
			addressPlaceHolder: "Nhập địa chỉ bạn muốn tìm kiếm.",
		});
		const filter = {
			...this.props.carFinding.filter,
			address: "",
			isOpenSearching: true,
		};
		this.setFilter(filter);
	};

	onSelectAddress = (address, i) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Trình duyệt không được cho phép truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
			this.showMessageBox(errMsg);
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			this.setState({
				err: commonErr.LOADING,
			});
			if (address.lat && address.lng) {
				this.setState({
					err: commonErr.SUCCESS,
					addressBanner: address.address,
					isAirDelivery: false,
				});

				const filter = {
					...this.props.carFinding.filter,
					address: address.address,
					lat: address.lat,
					lng: address.lng,
					isOpenSearching: true,
					deliveryId: undefined,
				};

				this.setFilter(filter);
				this.searchCar(filter);

				return;
			}

			searchInHouse(address.address)
				.then((response) => {
					// const loc = response.data.items[0].position
					const loc = response.data.data.locations[0];

					let location = { lat: loc.lat, lng: loc.lon };
					this.setState({
						err: commonErr.SUCCESS,
						addressBanner: address.address,
						isAirDelivery: false,
					});

					const filter = {
						...this.props.carFinding.filter,
						address: address.address,
						lat: location.lat,
						lng: location.lng,
						isOpenSearching: true,
						deliveryId: undefined,
					};

					this.setFilter(filter);
					this.searchCar(filter);
				})
				.catch((error) => {
					this.setState({
						err: commonErr.FAIL,
						errMsg: "Địa chỉ không hợp lệ. " + error,
					});
				});
		}
	};
	onDateRangeChange = (picker) => {
		let { endDate, startDate } = picker;
		const { startTime, endTime } = this.props.carFinding.filter;  
		// New picker value, only use (date, month, year)
		if (startDate && endDate) {
		
			startDate = moment(picker.startDate).set({
				hour: (startTime - startTime % 60) / 60,
				minute: startTime % 60,
				second: 0
					});
	
			endDate = moment(picker.endDate).set({
				hour: (endTime - endTime % 60) / 60,
				minute: endTime % 60,
				second: 0
			});

			// Specical case, not apply change

			const hour = Number((endTime - startTime)/60)
			const isSameDay = endDate.format('DD/MM/YYYY') == startDate.format('DD/MM/YYYY');

			if (isSameDay && (0 <= hour && hour < 2)) {
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				return;
			}

			// if (startDate && endDate && endDate.valueOf() === startDate.valueOf() && startTime >= endTime) {

			// 	return;
			// }

		

			// if (startDate && endDate && endDate.valueOf() < startDate.valueOf()) {
			// 	return;
			// }
	

			this.setState({
				startDate: startDate,
				endDate: endDate,
			});


			const filter = {
				...this.props.carFinding.filter,
				startDate: startDate,
				endDate: endDate,
				// isOpenSearching: true,
			};

			cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
			cookie.save("_mendts", endDate.valueOf(), { path: "/" });

			this.setFilter(filter);
			this.searchCar(filter);
		}
	};

	

	onStartTimeChange = (time) => {
		const { endTime } = this.props.carFinding.filter;  
		// const hour = (time - (time % 60)) / 60;
		// const min = time % 60;
		var startDate = moment(
			this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate
		).set({
			hour: (time - (time % 60)) / 60,
			minute: time % 60,
			second: 0,
			milliseconds: 0,
		});

		var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;

		const hour = Number((endTime - time)/60)
		const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY');

		if (isSameDay && (0 <= hour && hour < 2)) {
			return;
		} else if (startDate.valueOf() > endDate.valueOf()) {
			return;
		}


		// if (startDate && endDate && endDate.valueOf() === startDate.valueOf() && startTime >= endTime) {
		// 	return;
		// }

		// if (startDate && endDate && endDate.valueOf() < startDate.valueOf()) {
		// 	return;
		// }

		// if (endDate && endDate.isValid() && endDate <= startDate) {
		// 	endDate = startDate.clone().add(23, "hour");
		// }



		this.setState({
			startDate: startDate,
			startTime: time,
			endDate: endDate,
			// endTime: endDate.get("hour") * 60 + endDate.get("minute"),
			err: commonErr.SUCCESS,
			errMsg: "",
		});

		const filter = {
			...this.props.carFinding.filter,
			startDate: startDate,
			endDate: endDate,
			startTime: time,
			isOpenSearching: true,
		};

		// save cookies
		cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
		cookie.save("_mendts", endDate.valueOf(), { path: "/" });

		this.setFilter(filter);
		this.searchCar(filter);
	};

	onEndTimeChange = (time) => {
		const { startTime } = this.props.carFinding.filter;  
		// const hour = (time - (time % 60)) / 60;
		// const min = time % 60;
		var endDate = moment(this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate).set({
			hour: (time - (time % 60)) / 60,
			minute: time % 60,
			second: 0,
			milliseconds: 0,
		});

		var startDate = this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate;
		// if (startDate && startDate.isValid() && endDate <= startDate) {
		// 	startDate = endDate.clone().add(-23, "hour");
		// }
		const hour = Number((time - startTime)/60)
		const isSameDay = endDate.format('DD/MM/YYYY') == startDate.format('DD/MM/YYYY');

		if (isSameDay && (0 <= hour && hour < 2)) {
			return;
		} else if (startDate.valueOf() > endDate.valueOf()) {
			return;
		}
	
		// save cookies
		cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
		cookie.save("_mendts", endDate.valueOf(), { path: "/" });

		this.setState({
			// startDate: startDate,
			// startTime: startDate.get("hour") * 60 + startDate.get("minute"),
			endDate: endDate,
			endTime: time,
			err: commonErr.SUCCESS,
			errMsg: "",
		});

		const filter = {
			...this.props.carFinding.filter,
			startDate: startDate,
			endDate: endDate,
			endTime: time,
			isOpenSearching: true,
		};

		this.setFilter(filter);
		this.searchCar(filter);
	};

	showMessageBox = (msg) => {
		this.setState({
			errMsgBox: msg,
		});
	};

	hideMessageBox = () => {
		this.setState({
			errMsgBox: "",
		});
	};

	togglePopup = (car, isUpdate) => {
		const { isAirDelivery } = this.state;
		const state = { deliveryId: this.props.carFinding.filter.deliveryId };

		if (isUpdate === true) {
			window.history.pushState(state, "", `/car/${this.isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`);
			this.setState({
				popupCarId: car.id,
				// indexUrl: -3,
			});
		} else {
			if (!this.state.isShowPopup) {
		
				document.body.scrollTo(0, this.state.scrollTop);
				window.history.pushState(state, "", `/car/${this.isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`);
			
				this.setState({
					// indexUrl: -3,
				})
			} else {
				window.history.pushState(state, "", this.state.oriUrl);
				// this.setState({
				// 	indexUrl: -1,
				// })
			}
			this.setState({
				isShowPopup: !this.state.isShowPopup,
				popupCarId: car.id,
			});
		}
	};

	onHidePopup = () => {
		const state = { deliveryId: this.props.carFinding.filter.deliveryId };

		window.history.pushState(state, "", this.state.oriUrl);

		this.setState({
			isShowPopup: false,
		});
	};

	showAdvance = () => {
		this.setState({
			showAdvance: true,
		});
	};

	hideAdvance = () => {
		this.setState({
			showAdvance: false,
		});
	};

	hasFilter = (filter, customFilterConfig) => {
		if (filter === undefined || customFilterConfig === undefined) {
			return false;
		}
		const maxPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxPrice
				? customFilterConfig.maxPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxPrice
			? customFilterConfig.wdMaxPrice / 1000
			: defPriceRange.max;
		const minPrice = this.isSD
			? customFilterConfig && customFilterConfig.minPrice
				? customFilterConfig.minPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMinPrice
			? customFilterConfig.wdMinPrice / 1000
			: defPriceRange.min;
		const maxDPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxDeliveryPrice
				? customFilterConfig.maxDeliveryPrice / 1000
				: defDPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxDeliveryPrice
			? customFilterConfig.wdMaxDeliveryPrice / 1000
			: defDPriceRange.max;
		//
		const maxLimitKM =
			customFilterConfig && customFilterConfig.maxLimitKM ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice =
			customFilterConfig && customFilterConfig.maxLimitKMPrice
				? customFilterConfig.maxLimitKMPrice / 1000 + 5
				: defLimitKMPriceRange.max;
		const minFuelC =
			customFilterConfig && customFilterConfig.minFuelC ? customFilterConfig.minFuelC : defFuelCRange.min;
		const minSeat = customFilterConfig && customFilterConfig.seatMin ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = customFilterConfig && customFilterConfig.seatMax ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = customFilterConfig && customFilterConfig.yearMin ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = customFilterConfig && customFilterConfig.yearMax ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius =
			customFilterConfig && customFilterConfig.maxRadius ? customFilterConfig.maxRadius : defRadiusRange.max;
		const sortValue = customFilterConfig && customFilterConfig.sort ? customFilterConfig.sort : "op";

		return (
			filter.minPrice > minPrice ||
			filter.maxPrice < maxPrice ||
			(filter.vehicleType && filter.vehicleType.length > 0) ||
			filter.vehicleMake != "0" ||
			filter.vehicleModel.length > 0 ||
			filter.minSeat > minSeat ||
			filter.maxSeat < maxSeat ||
			filter.minYear > minYear ||
			filter.maxYear < maxYear ||
			filter.instantBooking === true ||
			filter.directDelivery === true ||
			filter.dPrice < maxDPrice ||
			filter.transmission != "0" ||
			filter.features.length > 0 ||
			filter.fuel != "0" ||
			filter.fuelC > minFuelC ||
			filter.limitKM !== 0 ||
			filter.limitKMPrice < maxLimitKMPrice ||
			filter.radius * 1.60934 < maxRadius ||
			filter.sort != sortValue[0].id ||
			filter.supportIns === true ||
			filter.ownerHostFiveStar === true ||
			filter.discount === true ||
			filter.nonMortgage === true
		);
	};

	toggleSearching = () => {
		if (this.state.isOpenSearching) {
			if (this.props.carFinding.filter.address == "") {
				const filter = {
					...this.props.carFinding.filter,
					address: this.state.addressBanner,
					isOpenSearching: false,
				};
				this.setFilter(filter);
			}
		}

		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: !this.state.isOpenSearching,
		};
		this.setFilter(filter);

		this.setState(
			{
				isOpenSearching: !this.state.isOpenSearching,
			},
			() => {
				this.checkOpenSearchBox();
			}
		);
	};

	hideSearching = () => {
		this.setState({
			isOpenSearching: false,
		});
	};

	toogleSearchTime = () => {
		this.setState({
			showSearchTime: !this.state.showSearchTime,
		});
	};

	checkOpenSearchBox = () => {
		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: this.state.isOpenSearching,
		};
		this.setFilter(filter);
	};

	isLogged = () => {
		const { profile } = this.props.session;
		return profile && profile.info && profile.info.uid;
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	openCalendar = () => {
		this.setState({
			isCalendar: true,
		});
	};

	hideCalendar = () => {
		this.setState({
			isCalendar: false,
		});
	};

	render() {
		var content;
		let { errMsg } = this.state;
		const {
			err,
			errMsgBox,
			isOpenFilter,
			isOpenSearching,
			isOpenFilterBox,
			isShowWdTypeInfoBox,
			isShowPopup,
			showAdvance,
			addressPlaceHolder,
			addressBanner,
			isHighlight,
			wdMinHourDetected,
			viewMode,
			customFilterConfig,
			startDate,
			endDate,
			startTime,
			endTime,
			vehicleTypes,
			vehicleMakes,
			popupCarId,
			directionsResponse,
			isSelectHour,
			isAirDelivery,
			showLoginForm,
			fixHeight,
			isCalendar,
			minDate,
			maxDate,
			indexUrl,
			prevUrl
		} = this.state;

		const { lat, lng, deliveryId } = this.props.carFinding.filter;
		const errCF = this.props.carFinding.err;

		if (err >= commonErr.SUCCESS && errMsg === "") {
			if (viewMode === viewModes.MAP) {
				content = (
					<div className="map-carfinding">
						<MapView
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCarMapMore={this.searchCarMapMore}
							setAddressPlaceHolder={this.setAddressPlaceHolder}
							togglePopup={this.togglePopup}
							stype={this.stype}
						/>
						<QuicklyFilter
							visible={this.visible}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isSD={this.isSD}
							toggleFilterBox={this.toggleFilterBox}
							viewMode={viewMode}
							isList={false}
						/>
					</div>
				);
			} else {
				content = (
					<>
						<QuicklyFilter
							visible={this.visible}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isSD={this.isSD}
							toggleFilterBox={this.toggleFilterBox}
							viewMode={viewMode}
						/>
						<ListView
							visible={this.visible}
							isAirDelivery={isAirDelivery}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							searchCarListMore={this.searchCarListMore}
							togglePopup={this.togglePopup}
							isLogged={this.isLogged()}
							showLoginForm={this.openLoginForm}
							stype={this.stype}
						/>
					</>
				);
			}
		} else {
			content = (
				<div className="list-car-section">
					<Empty img={empty} msg={errMsg !== "" ? errMsg : "Đã có lỗi xảy ra. Vui lòng thử lại."} />
				</div>
			);
		}

		return (
			<React.Fragment>
				{this.isSD ? (
					<Helmet>
						<meta
							name="keywords"
							content="thuê xe 7 chỗ, thuê xe 4 chỗ, xe 4 chỗ, thue xe tu lai 7 cho, thuê xe du lịch 7 chỗ, thuê xe 7 chỗ tự lái, xe du lịch 7 chỗ, thuê xe 7 chỗ tự lái tphcm, thuê xe tự lái 7 chỗ, thuê xe tự lái giá rẻ, giá thuê xe tự lái 7 chỗ, cho thue xe 7 chỗ, thue xe 7 cho, giá thuê xe 7 chỗ 1 ngày, thuê xe 7 chỗ tại hà nội, thuê xe 4 chỗ tự lái, cho thuê xe 4 chỗ, xe du lịch 4 chỗ, cho thue xe 4 chỗ, giá thuê xe 7 chỗ tự lái, giá thuê xe 7 chỗ tự lái, thuê xe bán tải tự lái, thuê xe du lịch 4 chỗ, thuê xe tự lái đà nẵng, thuê xe tự lái bình dương, thuê xe tự lái biên hòa, thuê xe tự lái đà lạt, thuê xe tự lái phú quốc, thuê xe tự lái quy nhơn, thuê xe tự lái nha trang, thuê xe tự lái hải phòng, thuê xe tự lái vũng tàu, thuê xe tự lái cần thơ, thuê xe ô tô tự lái đà nẵng, thuê xe ô tô tự lái bình dương, thuê xe ô tô tự lái biên hòa, thuê xe ô tô tự lái đà lạt, thuê xe ô tô tự lái phú quốc, thuê xe ô tô tự lái quy nhơn, thuê xe ô tô tự lái nha trang, thuê xe ô tô tự lái hải phòng, thuê xe ô tô tự lái vũng tàu, thuê xe ô tô tự lái cần thơ"
						/>
					</Helmet>
				) : (
					<Helmet>
						<meta
							name="keywords"
							content="thuê xe có lái, thuê xe 7 chỗ có tài xế, thuê xe có tài xế, thuê xe 4 chỗ có tài xế, giá thuê xe 7 chỗ có tài xế, cần thuê xe 4 chỗ có tài xế, cần thuê xe 7 chỗ có tài xế, thuê xe có tài, thuê xe có tài xế hà nội, cho thuê xe có tài, thuê xe ô tô có tài xế, thuê xe 7 chỗ có tài, thuê xe có tài xế tphcm, thuê xe có tài xế đà nẵng"
						/>
					</Helmet>
				)}

				<div className="mioto-layout">
					<Header fixed={viewMode === viewModes.LIST ? true : false} visible={this.visible} />
					<section className={`body ${isOpenSearching || isOpenFilter || fixHeight ? "fix-height" : ""}`}>
						{/* <WoayGame onFixHeight={this.onFixHeight} search={this.props.location ? this.props.location.search : ''} /> */}
						{/* Start Mobile */}
						<SearchFilterBox
							visible={this.visible}
							isSD={true}
							indexUrl={indexUrl}
							prevUrl={prevUrl}
							addressBanner={addressBanner}
							addressPlaceHolder={addressPlaceHolder}
							viewMode={viewMode}
							address={this.props.carFinding.filter.address}
							startDate={this.props.carFinding.filter.startDate}
							endDate={this.props.carFinding.filter.endDate}
							setMapView={this.setMapView}
							setListView={this.setListView}
							toggleFilter={this.toggleFilter}
							toggleSearching={this.toggleSearching}
							resetFilter={this.resetFilter}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
						/>

						{/* End Mobile */}
						<QuicklySearch
							visible={this.visible}
							viewMode={viewMode}
							indexUrl={indexUrl}
							prevUrl={prevUrl}
							addressPlaceHolder={addressPlaceHolder}
							startDate={startDate}
							endDate={endDate}
							minDate={minDate}
							maxDate={maxDate}
							isIOS={isIOS}
							calendarTemplate={calendarTemplate}
							onAddressChange={this.onAddressChange}
							onSelectAddress={this.onSelectAddress}
							onDateRangeChange={this.onDateRangeChange}
							openCalendar={this.openCalendar}
							startTime={startTime}
							endTime={endTime}
							isCalendar={isCalendar}
							searchCar={this.searchCar}
							hideCalendar={this.hideCalendar}
							onStartTimeChange={this.onStartTimeChange}
							onEndTimeChange={this.onEndTimeChange}
						/>

						{content}

						{errCF >= commonErr.SUCCESS || err >= commonErr.SUCCESS ? (
							<>
								{viewMode === viewModes.LIST ? (
									<div
										className={`show-list-map ${this.visibleBottom ? "" : "scroll-bottom"}`}
										onClick={this.setMapView}>
										<p>Bản đồ</p>
										<div className="wrap-svg">
											<IcMapCarFinding />
										</div>
									</div>
								) : (
									<div className="show-list-map" onClick={this.setListView}>
										<p>Danh sách</p>
										<div className="wrap-svg">
											<IcListCarFinding />
										</div>
									</div>
								)}
							</>
						) : null}
					</section>

					<SearchBox
						isShow={isOpenSearching}
						hide={this.hideSearching}
						isSD={true}
						startTime={startTime}
						endTime={endTime}
						address={this.props.carFinding.filter.address}
						onAddressChange={this.onAddressChange}
						onAddressFocus={this.onAddressFocus}
						onSelectAddress={this.onSelectAddress}
						onDateRangeChange={this.onDateRangeChange}
						onStartTimeChange={this.onStartTimeChange}
						onEndTimeChange={this.onEndTimeChange}
						calendarTemplate={calendarTemplate}
						startDate={startDate}
						endDate={endDate}
						minDate={minDate}
						maxDate={maxDate}
						isIOS={isIOS}
					/>

					{isOpenFilterBox && (
						<FilterPopup
							isShow={isOpenFilterBox}
							hide={this.hideFilterBox}
							vehicleType={this.props.carFinding.filter.vehicleType}
							viewModes={viewModes}
							viewMode={viewMode}
							defPriceRange={defPriceRange}
							defLimitKMRange={defLimitKMRange}
							defLimitKMPriceRange={defLimitKMPriceRange}
							defYearRange={defYearRange}
							defSeatRange={defSeatRange}
							defRadiusRange={defRadiusRange}
							defFuelCRange={defFuelCRange}
							defDPriceRange={defDPriceRange}
							filter={this.props.carFinding.filter}
							counters={this.props.carFinding.counters}
							customFilterConfig={customFilterConfig}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isShowAdvance={showAdvance}
							showMessageBox={this.showMessageBox}
							hideMessageBox={this.hideMessageBox}
							showAdvance={this.showAdvance}
							hideAdvance={this.hideAdvance}
							stype={this.stype}
						/>
					)}

					<FilterScreen
						isShow={isOpenFilter}
						hide={this.hideFilter}
						vehicleType={this.props.carFinding.filter.vehicleType}
						viewModes={viewModes}
						viewMode={viewMode}
						defPriceRange={defPriceRange}
						defLimitKMRange={defLimitKMRange}
						defLimitKMPriceRange={defLimitKMPriceRange}
						defYearRange={defYearRange}
						defSeatRange={defSeatRange}
						defRadiusRange={defRadiusRange}
						defFuelCRange={defFuelCRange}
						defDPriceRange={defDPriceRange}
						filter={this.props.carFinding.filter}
						counters={this.props.carFinding.counters}
						totalCar={this.props.carFinding.total}
						customFilterConfig={customFilterConfig}
						vehicleTypes={vehicleTypes}
						vehicleMakes={vehicleMakes}
						setFilter={this.setFilter}
						resetFilter={this.resetFilter}
						searchCar={this.searchCar}
						isShowAdvance={showAdvance}
						showMessageBox={this.showMessageBox}
						hideMessageBox={this.hideMessageBox}
						showAdvance={this.showAdvance}
						hideAdvance={this.hideAdvance}
						stype={this.stype}
					/>

					<MessageBox show={errMsgBox !== ""} hideModal={this.hideMessageBox} message={errMsgBox} />
					<WdTypeInfoBox show={isShowWdTypeInfoBox} hideModal={this.hideWdTypeInfoBox} wdType={wdType} />
					{isShowPopup ? (
						<CarDetailPopup
							show={isShowPopup}
							onHide={this.onHidePopup}
							togglePopup={this.togglePopup}
							carId={popupCarId}
							stype={this.stype}
							deliveryId={deliveryId}
						/>
					) : null}
						<Login
							show={showLoginForm}
							showModal={this.openLoginForm}
							hideModal={this.closeLoginForm}
							openSignupForm={this.openSignupForm}
							getLoggedProfile={this.getLoggedProfile}
						/>
						<SignUp
							show={this.state.showSignup}
							showModal={this.openSignupForm}
							hideModal={this.closeSignupForm}
							openLoginForm={this.openLoginForm}
							getLoggedProfile={this.getLoggedProfile}
						/>
				</div>
			</React.Fragment>
		);
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
		session: state.session,
		appInit: state.appInit
	};
}

CarFinding = connect(mapState)(CarFinding);
export default CarFinding;


// onStartDateChange = (event, picker) => {
	// 	event.preventDefault();

	// 	const { selectHour } = this.props.carFinding.filter;
	// 	if (picker.startDate) {
	// 		const startDate = picker.startDate;
	// 		var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
	// 		var endTime = endDate.get("hour") * 60 + endDate.get("minute");
	// 		var hour = this.state.startTime
	// 			? (this.state.startTime - (this.state.startTime % 60)) / 60
	// 			: (this.props.carFinding.filter.startTime - (this.props.carFinding.filter.startTime % 60)) / 60;
	// 		var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;
	// 		startDate.set({
	// 			hour: hour,
	// 			minute: minute,
	// 			second: 0,
	// 			milliseconds: 0,
	// 		});

	// 		if (endDate <= startDate) {
	// 			endDate = startDate
	// 				.clone()
	// 				.add(1, "days")
	// 				.set({
	// 					hour: endDate.get("hour"),
	// 					minute: endDate.get("minute"),
	// 					second: 0,
	// 					milliseconds: 0,
	// 				});
	// 		}

	// 		// save cookies
	// 		cookie.save(this.isSD ? "_mstartts" : "_mstarttswd", startDate.valueOf(), { path: "/" });
	// 		cookie.save(this.isSD ? "_mendts" : "_mendtswd", endDate.valueOf(), { path: "/" });

	// 		this.setState({
	// 			startDate: startDate,
	// 			endDate: endDate,
	// 			endTime: endTime,
	// 		});

	// 		this.toogleSearchTime();
	// 		const filter = {
	// 			...this.props.carFinding.filter,
	// 			startDate: startDate,
	// 			endDate: endDate,
	// 			isOpenSearching: true,
	// 		};

	// 		this.setFilter(filter);
	// 		this.searchCar(filter);

	// 		this.toogleSearchTime();
	// 	}
	// };

	// onEndDateChange = (event, picker) => {
	// 	event.preventDefault();

	// 	if (picker.startDate && picker.endDate) {
	// 		const startDate = picker.startDate;
	// 		startDate.set({
	// 			hour: (this.state.startTime - (this.state.startTime % 60)) / 60,
	// 			minute: this.state.startTime % 60,
	// 			second: 0,
	// 			milliseconds: 0,
	// 		});
	// 		const endDate = picker.endDate;
	// 		endDate.set({
	// 			hour: (this.state.endTime - (this.state.endTime % 60)) / 60,
	// 			minute: this.state.endTime % 60,
	// 			second: 0,
	// 			milliseconds: 0,
	// 		});
	// 		if (endDate < startDate) {
	// 			return;
	// 		}
	// 		// save cookies
	// 		cookie.save(this.isSD ? "_mstartts" : "_mstarttswd", startDate.valueOf(), { path: "/" });
	// 		cookie.save(this.isSD ? "_mendts" : "_mendtswd", endDate.valueOf(), { path: "/" });

	// 		this.setState({
	// 			startDate: startDate,
	// 			endDate: endDate,
	// 		});

	// 		const filter = {
	// 			...this.props.carFinding.filter,
	// 			startDate: startDate,
	// 			endDate: endDate,
	// 			isOpenSearching: true,
	// 		};

	// 		this.setFilter(filter);

	// 		this.searchCar(filter);
	// 	}
	// };